import notFound from './not-found.json'

export default {
    //Root directory
    notFound,
}
